import { coreCustomersCurrentFeatureFlagsGetAsyncSlice } from './get';

export const { requestGetCoreCustomersCurrentFeatureFlags, resetGetCoreCustomersCurrentFeatureFlags } =
	coreCustomersCurrentFeatureFlagsGetAsyncSlice.asyncActionCreators;
